import { render } from "./FileUploadDialog.vue?vue&type=template&id=504e1cef&scoped=true"
import script from "./FileUploadDialog.vue?vue&type=script&lang=js"
export * from "./FileUploadDialog.vue?vue&type=script&lang=js"

import "./FileUploadDialog.vue?vue&type=style&index=0&id=504e1cef&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-504e1cef"]])

export default __exports__